import { currentUser } from "@/App";
import NotebookLogo from "@/components/NotebookLogo";
import RsvpButton from "@/components/RsvpButton";
import { Close, QrCode } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";

export default function ExperienceCard({ content }) {
  const [rsvp, setRsvp] = useState(content.user_rsvp);
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  return (
    <Box sx={{ minWidth: "300px" }}>
      <Card style={{ borderRadius: "20px", margin: "20px 0" }}>
        <CardContent>
          <Typography variant="caption" color="secondary">
            ARTIST EXPERIENCE
          </Typography>
          <Typography variant="h6">{content.meta.title}</Typography>
          <Box>
            <Typography
              variant="caption"
              style={{ marginRight: "5px", color: "darkgray" }}
            >
              {content.meta.location} • {content.meta.when}
            </Typography>
          </Box>

          <CardMedia
            component="img"
            image={content.meta.cover}
            style={{ borderRadius: "20px" }}
            sx={{ my: 2 }}
          />

          <RsvpButton content={content} rsvp={rsvp} onRsvpChange={setRsvp} />
          {rsvp && (
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              style={{ marginTop: "10px" }}
              startIcon={<QrCode />}
              onClick={handleModalOpen}
            >
              View Ticket
            </Button>
          )}
          <TicketModal
            open={modalOpen}
            handleClose={handleModalClose}
            content={content}
          />
        </CardContent>
      </Card>
    </Box>
  );
}

function TicketModal({ open, handleClose, content }) {
  const host = window.location.origin;
  const url = `${host}/experience/${content.key}?user=${currentUser.key}`;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper sx={{ bgcolor: "background.paper", borderRadius: "20px" }}>
        <Box sx={{ p: 4, maxWidth: "400px" }}>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>

          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            gap={2}
            sx={{ mb: 4 }}
          >
            <Stack direction="column" spacing={2} alignItems="center">
              <Avatar
                src={currentUser.meta.profile}
                sx={{ width: 75, height: 75 }}
              />
              <Typography variant="h6">{currentUser.name}</Typography>
              <Typography variant="caption" color="secondary">
                {content.meta.bio}
              </Typography>
            </Stack>
            <QRCodeSVG value={url} size={150} />
          </Stack>
          <Stack direction="column" spacing={2} alignItems="center">
            <Typography variant="caption" color="info" textAlign="center">
              Artist Experience is limited to active Notebook Subscribers only.
              RSVP Does not guarantee entry - artist may have a limited
              capacity. Not Transferable.
            </Typography>
            <NotebookLogo />
          </Stack>
        </Box>
      </Paper>
    </Modal>
  );
}
